/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import StopStationSolid from '#/shared/components/GeneratedIcons/trimet/StopStationSolid';
import MapMarkerSolid from '#/shared/components/GeneratedIcons/trimet/MapMarkerSolid';

function GeocodedFeatureIcon(props) {
  const { feature } = props;
  return (
    {
      activity_center: <MapMarkerSolid isResult {...props} />,
      stops: <StopStationSolid isResult {...props} />,
    }[feature.properties.layer] || <MapMarkerSolid isResult {...props} />
  );
}

GeocodedFeatureIcon.propTypes = {
  feature: PropTypes.shape({
    properties: PropTypes.shape({ layer: PropTypes.string.isRequired }),
  }).isRequired,
};

export default GeocodedFeatureIcon;
